import routerOptions0 from "/usr/src/app/content/n3-spas-1a7343a3-ace6-4822-bd5c-a0ae05b31a68/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}